import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cream-white via-soft-gray to-cream-white">
      {/* Header with Back Button */}
      <div className="bg-charcoal text-cream-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-warm-sage hover:text-soft-taupe transition-colors mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour à l'accueil
          </Link>
          <div className="flex items-center space-x-4">
            <div className="bg-warm-sage/20 p-3 rounded-lg">
              <Cookie className="h-8 w-8 text-warm-sage" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-serif font-light">
                Politique des Cookies
              </h1>
              <p className="text-warm-gray font-light mt-1">
                Gestion et utilisation des cookies
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          
          <div className="prose prose-lg max-w-none">
            <p className="text-warm-gray italic mb-8">
              Dernière mise à jour : Janvier 2025
            </p>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Qu'est-ce qu'un cookie ?
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) lors de la visite d'un site web. 
                Il permet au site de mémoriser des informations sur votre visite, comme votre langue préférée et d'autres paramètres, afin de 
                faciliter votre prochaine visite et de rendre le site plus utile pour vous.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Utilisation des Cookies sur Notre Site
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Le site Mind'UP utilise des cookies pour améliorer votre expérience de navigation. Voici les différents types de cookies que nous utilisons :
              </p>
            </section>

            <section className="mb-10">
              <h3 className="text-xl font-serif font-light text-warm-sage mb-3">
                1. Cookies Strictement Nécessaires
              </h3>
              <p className="text-charcoal leading-relaxed mb-4">
                Ces cookies sont essentiels au fonctionnement du site web et ne peuvent pas être désactivés dans nos systèmes. 
                Ils sont généralement établis en réponse à des actions que vous effectuez et qui correspondent à une demande de services, 
                telles que la définition de vos préférences en matière de confidentialité, la connexion ou le remplissage de formulaires.
              </p>
              <ul className="list-disc pl-6 space-y-2 text-charcoal">
                <li>Gestion de session</li>
                <li>Sécurité du site</li>
                <li>Mémorisation de vos préférences de langue</li>
              </ul>
            </section>

            <section className="mb-10">
              <h3 className="text-xl font-serif font-light text-warm-sage mb-3">
                2. Cookies de Performance et d'Analyse
              </h3>
              <p className="text-charcoal leading-relaxed mb-4">
                Ces cookies nous permettent de compter les visites et les sources de trafic afin de mesurer et d'améliorer les performances de notre site. 
                Ils nous aident à savoir quelles pages sont les plus et les moins populaires et à voir comment les visiteurs naviguent sur le site.
              </p>
              <p className="text-charcoal leading-relaxed">
                <strong>Important :</strong> Ces cookies sont soumis à votre consentement préalable.
              </p>
            </section>

            <section className="mb-10">
              <h3 className="text-xl font-serif font-light text-warm-sage mb-3">
                3. Cookies de Fonctionnalité
              </h3>
              <p className="text-charcoal leading-relaxed">
                Ces cookies permettent au site d'offrir des fonctionnalités améliorées et une personnalisation. Ils peuvent être définis par nous ou 
                par des tiers dont nous avons ajouté les services à nos pages. Si vous n'autorisez pas ces cookies, certains de ces services peuvent 
                ne pas fonctionner correctement.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Cookies Tiers
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Nous pouvons utiliser des services tiers qui déposent leurs propres cookies pour nous aider à améliorer votre expérience :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-charcoal">
                <li><strong>Google Analytics</strong> (si activé) : Pour analyser l'utilisation du site</li>
                <li><strong>Outils de réservation</strong> : Pour faciliter la prise de rendez-vous</li>
              </ul>
              <p className="text-charcoal leading-relaxed mt-4">
                Ces services tiers ont leurs propres politiques de confidentialité et de cookies que nous vous encourageons à consulter.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Durée de Conservation des Cookies
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Les cookies ont des durées de vie variables :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-charcoal">
                <li><strong>Cookies de session</strong> : Supprimés automatiquement lorsque vous fermez votre navigateur</li>
                <li><strong>Cookies persistants</strong> : Restent sur votre appareil jusqu'à expiration (généralement 13 mois maximum) ou jusqu'à ce que vous les supprimiez manuellement</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Gestion de Vos Préférences
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Vous pouvez à tout moment gérer vos préférences en matière de cookies :
              </p>
              
              <h3 className="text-lg font-serif font-medium text-warm-sage mb-3 mt-6">
                Via Votre Navigateur
              </h3>
              <p className="text-charcoal leading-relaxed mb-4">
                La plupart des navigateurs vous permettent de :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-charcoal mb-4">
                <li>Consulter les cookies stockés</li>
                <li>Refuser ou supprimer tous les cookies ou seulement certains</li>
                <li>Définir vos préférences avant de visiter un site web</li>
              </ul>

              <div className="bg-soft-gray/20 p-6 rounded-xl border border-warm-sage/20 mb-4">
                <p className="text-charcoal font-medium mb-3">Liens vers les paramètres des principaux navigateurs :</p>
                <ul className="space-y-2 text-charcoal text-sm">
                  <li>• <strong>Chrome</strong> : Paramètres → Confidentialité et sécurité → Cookies</li>
                  <li>• <strong>Firefox</strong> : Paramètres → Vie privée et sécurité → Cookies</li>
                  <li>• <strong>Safari</strong> : Préférences → Confidentialité → Cookies</li>
                  <li>• <strong>Edge</strong> : Paramètres → Cookies et autorisations de site</li>
                </ul>
              </div>

              <p className="text-charcoal leading-relaxed text-sm italic">
                <strong>Note :</strong> Le blocage de certains cookies peut affecter la fonctionnalité du site et empêcher certaines fonctionnalités de fonctionner correctement.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Cookies et Données Personnelles
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Les cookies strictement nécessaires ne collectent pas de données personnelles identifiables. Les autres types de cookies peuvent 
                collecter des informations telles que votre adresse IP, votre type de navigateur et votre comportement de navigation.
              </p>
              <p className="text-charcoal leading-relaxed">
                Pour plus d'informations sur la façon dont nous traitons vos données personnelles, veuillez consulter notre 
                <Link to="/datenschutz" className="text-warm-sage hover:underline ml-1">Politique de Confidentialité</Link>.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Mise à Jour de Cette Politique
              </h2>
              <p className="text-charcoal leading-relaxed">
                Nous pouvons mettre à jour cette politique des cookies de temps à autre pour refléter les changements dans nos pratiques ou 
                pour d'autres raisons opérationnelles, légales ou réglementaires. Nous vous encourageons à consulter régulièrement cette page 
                pour rester informé(e).
              </p>
            </section>

            <div className="bg-warm-sage/10 p-6 rounded-xl border border-warm-sage/20 mt-12">
              <p className="text-charcoal leading-relaxed">
                <strong className="text-warm-sage">Questions sur les Cookies ?</strong><br />
                Si vous avez des questions concernant notre utilisation des cookies, n'hésitez pas à nous contacter à :<br />
                <a href="mailto:contact@mindup-coaching.com" className="text-warm-sage hover:underline">
                  contact@mindup-coaching.com
                </a>
              </p>
            </div>
          </div>

        </div>

        {/* Back to Home Button */}
        <div className="text-center mt-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-warm-sage hover:text-charcoal transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
